<template>
  <section class="app-carousel-card">
    <div class="row">
      <div class="col-lg-3 mb-8 flex flex-col lg:mb-0">
        <h2 class="alt text-balance"><slot name="title"></slot></h2>

        <div class="mt-auto hidden lg:flex">
          <UiPagination
            v-if="carouselState && carouselState.total > 1"
            class="mt-8"
            :current="carouselState.current"
            :total="carouselState.total"
            :previous-disabled="carouselState.previousDisabled"
            :next-disabled="carouselState.nextDisabled"
            @previous="previous"
            @next="next"
          />
        </div>
      </div>

      <div class="col-lg-9">
          <component :is="paper ? AppPaper : 'div'">
            <UiCarousel
              ref="uiCarouselRef"
              :options="{ autoPlay }"
              @update="onUpdate"
            >
              <slot></slot>
            </UiCarousel>
          </component>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import AppPaper from './AppPaper.vue'
import UiPagination from '@boats/ui/components/UiPagination.vue'
import UiCarousel from '@boats/ui/components/UiCarousel.vue'

defineProps<{ paper?: boolean; autoPlay?: boolean | number }>()

const uiCarouselRef = ref()
const carouselState = ref<any>(null)

const previous = () => uiCarouselRef.value.previous()
const next = () => uiCarouselRef.value.next()
const onUpdate = (state: any) => (carouselState.value = state)
</script>
